import React , { useState }from 'react'
import {
    TextField,
    IconButton,
    InputAdornment
} from '@mui/material'
import {
    Person,
    Visibility,
    VisibilityOff
} from '@mui/icons-material'
export function UsernameField(props) {
    return (
        <TextField fullwidth label={props.label} disabled={props.disabled} value={props.username} sx={{width:'-webkit-fill-available'}} variant="outlined" InputProps={{ // <-- This is where the toggle button is added.
            endAdornment: (
            <InputAdornment position="end">
                <IconButton
                aria-label="user"
                >
                <Person/>
                </IconButton>
            </InputAdornment>
            )
        }}
        onChange={props.onChange}
        errorText={props.error}
        />
    )
}


export function PasswordField(props) {
    const [showState, setShowState] = useState(false)
    // const a = true
    return (
        <TextField  sx={{width:'-webkit-fill-available'}} value={props.password} type={showState? 'test':'password'}
        InputProps={{ // <-- This is where the toggle button is added.
            endAdornment: (
                <InputAdornment position="end">
                <IconButton
                    aria-label="toggle password visibility"
                    onClick={()=>setShowState(!showState)}
                    onMouseDown={()=>setShowState(false)}
                >
                    {showState ? <Visibility /> : <VisibilityOff />}
                </IconButton>
                </InputAdornment>
            )
            }}
        label="Password" onChange={props.onChange} variant="outlined" errorText={props.error}></TextField>
    );
}
